import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { ShieldCheck, Award } from "lucide-react";

export default function GuaranteeBadge() {
  const { t } = useTranslation();
  return (
    <section className="max-w-4xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6 }}
        className="rounded-3xl p-6 sm:p-10 border-2 border-primary-c/30 bg-white shadow-lg relative overflow-hidden"
        data-testid="guarantee-badge"
      >
        <div className="absolute -top-16 -right-16 w-48 h-48 bg-primary-c/5 rounded-full blur-3xl" />
        <div className="relative grid md:grid-cols-[80px_1fr] gap-5 items-center">
          <div className="mx-auto md:mx-0">
            <div className="w-20 h-20 rounded-3xl bg-gradient-to-br from-primary-c to-[#1F5E47] flex items-center justify-center text-white shadow-lg">
              <ShieldCheck className="w-10 h-10" strokeWidth={1.7} />
            </div>
          </div>
          <div>
            <div className="flex items-center gap-2 flex-wrap">
              <span className="text-[11px] font-bold uppercase tracking-wider text-secondary-c bg-secondary-c/10 px-3 py-1 rounded-full inline-flex items-center gap-1.5">
                <Award className="w-3.5 h-3.5" /> {t("guarantee.badge")}
              </span>
            </div>
            <h2 className="font-display text-2xl sm:text-3xl mt-3 leading-tight">
              {t("guarantee.title")} <span className="font-serif-italic text-primary-c">{t("guarantee.title_accent")}</span>
            </h2>
            <p className="mt-3 text-sm sm:text-base text-text-secondary leading-relaxed">
              {t("guarantee.desc")}
            </p>
            <div className="mt-4 grid sm:grid-cols-3 gap-3">
              {["p1", "p2", "p3"].map((k) => (
                <div key={k} className="flex items-start gap-2 text-xs sm:text-sm">
                  <ShieldCheck className="w-4 h-4 text-primary-c mt-0.5 shrink-0" />
                  <span>{t(`guarantee.${k}`)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
